import { inject, Service } from "@angular/core";

import {
  IntpCountryModel,
  IntpCountrySectorModel,
  IntpCountryVisitModel,
  IntpDashboardProjectModel,
  IntpDashboardStatsModel,
  MainResponseModel,
} from "../models";
import { MainService } from ".";

@Service()
export class IntpCountriesApiService {
  private _mainService = inject(MainService);

  public getById(id: number) {
    return this._mainService.sendRequest<MainResponseModel<IntpCountryModel>>({
      method: "GET",
      url: `country-page/getById/${id}`,
    });
  }

  public saveCountry(isEdit: boolean, isFinish: boolean, model: IntpCountryModel) {
    return this._mainService.sendRequest<MainResponseModel>({
      method: "POST",
      url: isEdit ? `country-page/update?isFinish=${isFinish}` : `country-page/create?isFinish=${isFinish}`,
      data: model,
    });
  }

  public deleteCountry(id: number) {
    return this._mainService.sendRequest<MainResponseModel>({
      method: "DELETE",
      url: `country-page/deleteById/${id}`,
    });
  }

  public getCountries() {
    return this._mainService.sendRequest<MainResponseModel<IntpCountryModel[]>>({
      method: "POST",
      url: `country-page/getCountries`,
      data: {},
    });
  }

  public getAllSectorsByCountry(countryId: number) {
    return this._mainService.sendRequest<MainResponseModel<IntpCountrySectorModel[]>>({
      method: "POST",
      url: `country-page/getAllSectorsByCountry/${countryId}`,
      data: {},
    });
  }

  public getDashboardStats(countryId: number) {
    return this._mainService.sendRequest<MainResponseModel<IntpDashboardStatsModel>>({
      method: "GET",
      url: `country-page/stats/${countryId}`,
    });
  }

  public getDashboardVisits(countryId: number) {
    return this._mainService.sendRequest<MainResponseModel<IntpCountryVisitModel[]>>({
      method: "GET",
      url: `country-page/visits/${countryId}`,
    });
  }

  public getDashboardProjects(countryId: number) {
    return this._mainService.sendRequest<MainResponseModel<IntpDashboardProjectModel[]>>({
      method: "GET",
      url: `country-page/projects/${countryId}`,
    });
  }
}
